/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { DecimalSchema } from '../common';
import { Decimal } from 'decimal.js';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    auctionStartDate: z.coerce.date(),
    auctionEndDate: z.coerce.date(),
    startingBid: DecimalSchema.refine(v => {
        try {
            return new Decimal(v.toString()).gte(0);
        } catch {
            return false;
        }
    }, { message: "Starting bid must be greater than 0." }),
    reserveBidAmount: DecimalSchema.nullish(),
    bidIncrement: DecimalSchema.refine(v => {
        try {
            return new Decimal(v.toString()).gt(0);
        } catch {
            return false;
        }
    }, { message: "Bid increment must be greater than 0." }).default(10),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    auctionStartDate: z.coerce.date(),
    auctionEndDate: z.coerce.date(),
    startingBid: DecimalSchema.refine(v => {
        try {
            return new Decimal(v.toString()).gte(0);
        } catch {
            return false;
        }
    }, { message: "Starting bid must be greater than 0." }),
    reserveBidAmount: DecimalSchema.nullish(),
    bidIncrement: DecimalSchema.refine(v => {
        try {
            return new Decimal(v.toString()).gt(0);
        } catch {
            return false;
        }
    }, { message: "Bid increment must be greater than 0." }),
}
).strict();
const relationSchema = z.object({
    listing: z.record(z.string(), z.unknown()),
    bids: z.array(z.unknown()).optional(),
    winningBid: z.record(z.string(), z.unknown()).optional(),
}
);
const fkSchema = z.object({
    listingId: z.string(),
    winningBidId: z.string().nullish(),
}
);

/**
* Schema refinement function for applying `@@validate` rules.
*/
export function refineAuctionFormat<T, D extends z.ZodTypeDef>(schema: z.ZodType<T, D, T>) {
    return schema.refine((value: any) => ((value?.auctionEndDate) !== undefined ? (((value?.auctionStartDate) !== undefined ? ((value?.auctionStartDate < value?.auctionEndDate)) : true)) : true), { message: "Auction end date must be after the start date.", path: ['auctionStartDate', 'auctionEndDate'], })
        .refine((value: any) => ((value?.auctionStartDate) !== undefined ? ((value?.auctionStartDate > (new Date()))) : true), { message: "Auction start date must be in the future.", path: ['auctionStartDate'], })
        .refine((value: any) => ((value?.auctionEndDate) !== undefined ? ((value?.auctionEndDate > (new Date()))) : true), { message: "Auction end date must be in the future.", path: ['auctionEndDate'], })
        .refine((value: any) => ((value?.reserveBidAmount === null || value?.reserveBidAmount === undefined) || ((value?.startingBid) !== undefined ? (((value?.reserveBidAmount) !== undefined ? ((value?.reserveBidAmount > value?.startingBid)) : true)) : true)), { message: "Reserve bid must be greater than the starting bid.", path: ['reserveBidAmount', 'startingBid'], });
}


/**
 * `AuctionFormat` schema excluding foreign keys and relations.
 */
export const AuctionFormatScalarSchema = baseSchema;


/**
 * `AuctionFormat` schema prior to calling `.refine()` for extensibility.
 */
export const AuctionFormatWithoutRefineSchema = AuctionFormatScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * `AuctionFormat` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const AuctionFormatSchema = refineAuctionFormat(AuctionFormatWithoutRefineSchema);


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const AuctionFormatPrismaCreateSchema = refineAuctionFormat(baseSchemaWithoutDefaults.partial().passthrough());


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const AuctionFormatPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    auctionStartDate: z.coerce.date(),
    auctionEndDate: z.coerce.date(),
    startingBid: DecimalSchema.refine(v => {
        try {
            return new Decimal(v.toString()).gte(0);
        } catch {
            return false;
        }
    }, { message: "Starting bid must be greater than 0." }),
    reserveBidAmount: DecimalSchema.nullish(),
    bidIncrement: DecimalSchema.refine(v => {
        try {
            return new Decimal(v.toString()).gt(0);
        } catch {
            return false;
        }
    }, { message: "Bid increment must be greater than 0." })
}).partial().passthrough();


/**
 * `AuctionFormat` schema for create operations excluding foreign keys and relations.
 */
export const AuctionFormatCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, bidIncrement: true
});


/**
 * `AuctionFormat` schema for create operations prior to calling `.refine()` for extensibility.
 */
export const AuctionFormatCreateWithoutRefineSchema = AuctionFormatCreateScalarSchema.merge(fkSchema);


/**
 * `AuctionFormat` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const AuctionFormatCreateSchema = refineAuctionFormat(AuctionFormatCreateWithoutRefineSchema);


/**
 * `AuctionFormat` schema for update operations excluding foreign keys and relations.
 */
export const AuctionFormatUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `AuctionFormat` schema for update operations prior to calling `.refine()` for extensibility.
 */
export const AuctionFormatUpdateWithoutRefineSchema = AuctionFormatUpdateScalarSchema.merge(fkSchema.partial());


/**
 * `AuctionFormat` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const AuctionFormatUpdateSchema = refineAuctionFormat(AuctionFormatUpdateWithoutRefineSchema);

